import URL from './url'
import http from '@/utils/httpUtils'

export default {
  getAccessDeviceList: postData =>
    http.get(URL.API_GET_ACCESS_DEVICE_LIST, postData),
  getCustomH5Config: postData =>
    http.get(URL.API_GET_CUSTOM_H5_CONFIG, postData),
  addAccessDevice: postData => http.post(URL.API_OPENDOOR_DEVICE_ADD, postData),
  // 删除进出校设备
  deleteAccessDevice: postData =>
    http.post(URL.API_OPENDOOR_DEVICE_DELETE, postData),
  // 查询进出校设备
  listAccessDevice: postData =>
    http.get(URL.API_OPENDOOR_DEVICE_LIST, postData),
  // 删除进出校权限组
  deleteAccessGroup: postData =>
    http.post(URL.API_OPENDOOR_GROUP_DELETE, postData),
  // 进出校权限组详情
  detailAccessGroup: postData =>
    http.get(URL.API_OPENDOOR_GROUP_DETAIL, postData),
  // 编辑进出校组
  editAccessGroup: postData => http.post(URL.API_OPENDOOR_GROUP_EDIT, postData),
  // 进出校权限组列表
  listAccessGroup: postData => http.get(URL.API_OPENDOOR_GROUP_LIST, postData),
  // POST新增进出校权限组
  saveAccessGroup: postData => http.post(URL.API_OPENDOOR_GROUP_SAVE, postData),
  getFacedoorGroupCount: postData =>
    http.get(URL.API_FACEDOOR_GROUP_COUNT, postData),
  // 自定义配置获取配置--机构维度
  getCustomConfigByOrg: postData =>
    http.get(URL.API_GET_CUSTOM_CONFIG_BY_ORG, postData),
  // 获取学生到校信息
  getArriveSchoolInfo: postData =>
    http.post(URL.API_OPENDOOR_GROUP_NOTICE, postData)
}
